<script lang="ts">
	import coffeStoreImageXs from "@assets/images/coffee-store-mobile.jpg?webp&w=800&imagetools";
	import coffeeStoreImage3xl from "@assets/images/coffee-store.jpg?webp&imagetools";
	import coffeStoreImageSm from "@assets/images/coffee-store.jpg?webp&w=960&imagetools";
	import coffeStoreImageMd from "@assets/images/coffee-store.jpg?webp&w=1280&imagetools";
	import coffeStoreImageLg from "@assets/images/coffee-store.jpg?webp&w=1600&imagetools";
	import coffeeStoreImageXl from "@assets/images/coffee-store.jpg?webp&w=1920&imagetools";
	import coffeeStoreImage2xl from "@assets/images/coffee-store.jpg?webp&w=2400&imagetools";
	import { ButtonSize } from "@components/common/ButtonSize.js";
	import { ButtonVariant } from "@components/common/ButtonVariant.js";
	import Formatted from "@components/common/Formatted.svelte";
	import Link from "@components/common/Link.svelte";
	import { getTranslate } from "@utils/getTranslate.js";
	import { Locale } from "@core/schema/Locale.js";
	import { getPostDetailPath } from "@core/schema/paths/getPostDetailPath.js";
	import { getGlobalTemplateProps } from "../../contexts/getGlobalTemplateProps.js";
	import translations from "./CoffeeStoreSection.translations.json" with { type: "json" };
	import ImageSection from "./ImageSection.svelte";

	const translate = getTranslate(translations);
	const { tenant } = getGlobalTemplateProps();
</script>

<ImageSection
	sources={{
		default: coffeStoreImageXs,
		">sm": coffeStoreImageSm,
		">md": coffeStoreImageMd,
		">lg": coffeStoreImageLg,
		">xl": coffeeStoreImageXl,
		">2xl": coffeeStoreImage2xl,
		">3xl": coffeeStoreImage3xl,
	}}
	heading={{ level: 2, text: translate("coffeeStore"), class: "[:has(>&)]:h-full [:has(>&)]:justify-center" }}
	class="!h-[75vh] [&_.grid-container]:grid-rows-[1fr_auto] [&_.grid-container>*]:justify-center"
	contentAlign="left"
	media="object-top sm:object-left"
	darkOverlay={false}
>
	{#snippet actions()}
		<Link
			size={ButtonSize.Medium}
			variant={ButtonVariant.White}
			href={getPostDetailPath({
				locale: tenant.locale,
				// Hardcoded URL – the client wants the link to point to this specific article.
				urlSlug: {
					[Locale.cs]: "novy-domov-vyberove-kavy-v-praze-takto-vznikl-nas-fathers-coffee-store-v-prazske-bubenci",
					[Locale.en]: "a-new-home-for-specialty-coffee-in-prague-the-story-behind-our-fathers-coffee-store-in-bubenec",
				}[tenant.locale],
			})}
		>
			<Formatted text={translate("moreInformation")} />
		</Link>
	{/snippet}
	{#snippet paragraph()}
		<div class="text-white font-bold italic max-w-105 xl:text-lg/normal">
			<Formatted text={translate("address")} />
		</div>
		<p class="text-white font-extralight max-w-105 xl:text-lg/normal md:my-5">
			<Formatted text={translate("discoverOffer")} />
		</p>
		<p class="text-white font-bold max-w-105 xl:text-lg/normal mb-6">
			<Formatted text={translate("openingHours")} />
		</p>
	{/snippet}
</ImageSection>
